import { render, staticRenderFns } from "./ModalDetalhes.vue?vue&type=template&id=6385d1e4"
import script from "./ModalDetalhes.vue?vue&type=script&lang=js"
export * from "./ModalDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhes.vue?vue&type=style&index=0&id=6385d1e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports